import { addEventOnce } from "../../utils/events/events";
import { onReady } from "../../utils/events/onReady";
import {
    disableScrollLock,
    enableScrollLock,
} from "../../utils/dom/scrollLock";

export class InformationModal {
    // Strictly necessary legal-gate acknowledgment, scoped to one browser session.
    acceptedModalsStorageKey = "information-modal-accepted";

    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined,
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        this.dom.loader = document.querySelector(
            ".information-modal__loading-overlay",
        );
        this.dom.classList = {
            hiddenClass: "hidden",
            informationModalActive: "information-modal--active",
            informationModalClose: "information-modal__close",
        };
        onReady(() => this.init(domReference));
    }

    getAcceptedModals() {
        const acceptedModals = window.sessionStorage.getItem(
            this.acceptedModalsStorageKey,
        );

        if (!acceptedModals) {
            return [];
        }

        return acceptedModals.split("|").filter(Boolean);
    }
    setAcceptedModals(modalIds) {
        // Save directly in sessionStorage (no consent gate) because this is required
        // for core legal/compliance flow and is not used for analytics or marketing.
        window.sessionStorage.setItem(
            this.acceptedModalsStorageKey,
            modalIds.join("|"),
        );
    }
    acceptModal(modalId) {
        if (!modalId) {
            return;
        }

        const acceptedModals = this.getAcceptedModals();
        if (!acceptedModals.includes(modalId)) {
            acceptedModals.push(modalId);
            this.setAcceptedModals(acceptedModals);
        }
    }
    showInformationModal() {
        this.dom.container.classList.add(
            this.dom.classList.informationModalActive,
        );
        this.dom.loader.classList.add(this.dom.classList.hiddenClass);

        enableScrollLock();
    }
    hideInformationModal(modalId) {
        this.acceptModal(modalId);
        this.dom.container.classList.remove(
            this.dom.classList.informationModalActive,
        );
        disableScrollLock();
    }
    init(domReference) {
        const self = this;
        const close = domReference.querySelector(
            `.${self.dom.classList.informationModalClose}`,
        );
        const modalId = domReference.dataset.id;

        addEventOnce(close, "click", () => {
            this.hideInformationModal(modalId);
        });
        const acceptedModals = this.getAcceptedModals();
        const isModalAccepted = acceptedModals.includes(modalId);

        if (!isModalAccepted) {
            this.showInformationModal();
        }
        this.dom.loader.classList.add(this.dom.classList.hiddenClass);
    }
}
